/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralParameterKey } from '../../models/general-parameter-key';
import { GeneralParameterUpdate } from '../../models/general-parameter-update';

export interface UpdateGeneralParameter$Params {

/**
 * The referenced general parameter key
 */
  key: GeneralParameterKey;
  
    /**
     * The general parameter update object
     */
    body: GeneralParameterUpdate
}

export function updateGeneralParameter(http: HttpClient, rootUrl: string, params: UpdateGeneralParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateGeneralParameter.PATH, 'put');
  if (params) {
    rb.path('key', params.key, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateGeneralParameter.PATH = '/custom/parameters/{key}';
